webpackJsonp([17953591736895156000],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/about.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---about-586c7e095e534a3909ec.js